module.exports = __webpack_public_path__ + "static/media/icon-character__karl-marx.e109c3ca.svg";